
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/components/Button';
import navigationOptionRedirect from "../util/navigationOptionRedirect";

export default function navigationOptionDropdown(item){
  let decorationStoreDisplayNameSetting = app.forum.attribute("decorationStoreDisplayName");
  let decorationStoreDisplayName = app.translator.trans(decorationStoreDisplayNameSetting===""?'ziven-decoration-store.forum.display-name-default':decorationStoreDisplayNameSetting);
    
  const navigateOption = {
      item0: {name:decorationStoreDisplayName,icon:'fas fa-store',selected:item==="item0"},
      item1: {name:app.translator.trans('ziven-decoration-store.forum.my-decoration'),icon:'fas fa-box-open',selected:item==="item1"},
      item2: {name:app.translator.trans('ziven-decoration-store.forum.purchase-history'),icon:'fas fa-list',selected:item==="item2"},
    };

  const optionLabel = navigateOption[item].name;

  return Dropdown.component({
      buttonClassName: 'Button DecorationStoreNavigateDropdown',
      label: optionLabel,
    },
    Object.keys(navigateOption).map((key) => {
      const opitonData = navigateOption[key];
      const optionSelected = opitonData.selected===true;
      const optionClass = optionSelected?"DecorationStoreNavigateOptionSelected":"";

      return Button.component({
          className: optionClass,
          icon: opitonData.icon,
          onclick: () => navigationOptionRedirect(key),
        },
        opitonData.name
      );
    })
  )
}
